import { Throwable } from "@wss/error-tracking/throwable";
import { toError } from "@wss/error-tracking/utils";
import { Product } from "~/common/Store/models/ProductListing";

const fetchSimilarItems = async (
  itemNumber: string,
  title: string,
  excludedItemNumbers: string[],
): Promise<Throwable<Product[]>> => {
  const params = new URLSearchParams(window.location.search);
  const productIsHidden = params.get("showhidden");
  if (productIsHidden) {
    return { isError: false, value: [] };
  }

  try {
    const response = await fetch("/api/similarproducts", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        itemNumber,
        excludedItemNumbers,
      }),
    });

    if (response.ok) {
      const carouselItems = await response.json<Product[]>();
      return { isError: false, value: carouselItems };
    }
    return { isError: true, error: new Error(response.statusText) };
  } catch (e) {
    const error = new Error("Error retrieving similarProducts", {
      cause: toError(e),
    });
    return { isError: true, error };
  }
};

export default fetchSimilarItems;
